import Translate from '../../i18n/Translate'

//Components
import ReservationForm from '../../components/ItineraryDetail/ReservationForm'

//Intersection
import { useInView } from 'react-intersection-observer'

const Reservations = ({ nameItinerary, idItinerary }) => {
    const [formWrapper, inView] = useInView({
        triggerOnce: true,
        threshold: 0.2,
    })

    return (
        <section className="incoming-itinerary-detail__reservations">
            <h2 className="title">
                <Translate langkey="itinerary_detail.reservations.title" />
            </h2>
            <p className="copy">
                <Translate langkey="itinerary_detail.reservations.copy" />
            </p>

            <div className="bg-container">
                <div className={`form-wrapper animate slide-right ${inView ? 'in-view' : ''}`} ref={formWrapper}>
                    <ReservationForm nameItinerary={nameItinerary} idItinerary={idItinerary} />
                </div>
                <div className="professional-access">
                    <h3 className="access-title">
                        <Translate langkey="itinerary_detail.reservations.access.title" />
                    </h3>
                    <p className="access-copy">
                        <Translate langkey="itinerary_detail.reservations.access.copy" />
                    </p>
                    <div className="btn-container">
                        <a href="/#" target="_blank" className="btn">
                            <span>
                                <Translate langkey="itinerary_detail.reservations.access.button1" />
                            </span>
                        </a>
                        <a href="/#" target="_blank" className="btn btn-login">
                            <span>
                                <Translate langkey="itinerary_detail.reservations.access.button2" />
                            </span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Reservations
